import API from 'constants/API';

import axios, {AxiosResponse} from 'axios';
import {ChangePasswordDTO, ForgotPasswordDTO, LoginDTO, RegisterDTO} from 'typescript/dto/authDto';
import UpdateUserDTO from 'typescript/dto/userDto';
import ApiData from 'typescript/interfaces/ApiData';
import User from 'typescript/models/User';
import UserBase from 'typescript/models/UserBase';
import httpClient from 'utils/httpClient/httpClient';

export const login = (loginData: LoginDTO, useAxios?: boolean): Promise<AxiosResponse<UserBase>> => {
  const requestData = {user: loginData};

  if (!useAxios) {
    return httpClient.post(API.AUTH_SERVICE.SIGN_IN, requestData);
  }

  return axios.post(API.AUTH_SERVICE.SIGN_IN, requestData, {
    baseURL: process.env.REACT_APP_API_URL,
  });
};

export const register = (registerData: RegisterDTO): Promise<AxiosResponse<UserBase>> => {
  const requestData = {user: registerData};

  return httpClient.post(API.AUTH_SERVICE.BASE, requestData);
};

export const resetPass = (data: ForgotPasswordDTO): Promise<AxiosResponse<{}>> => {
  const requestData = {user: data};

  return httpClient.post(API.AUTH_SERVICE.PASSWORD, requestData);
};

export const deleteAccount = (token: string, useAxios?: boolean): Promise<AxiosResponse<undefined>> => {
  if (!useAxios) {
    return httpClient.delete(API.AUTH_SERVICE.BASE);
  }

  return axios.delete(API.AUTH_SERVICE.BASE, {
    baseURL: process.env.REACT_APP_API_URL,
    headers: {Authorization: token},
  });
};

export const changePass = (data: ChangePasswordDTO): Promise<AxiosResponse<{}>> => {
  const requestData = {user: data};

  return httpClient.put(API.AUTH_SERVICE.BASE, requestData);
};

export const getUserData = (userId: number): Promise<AxiosResponse<User>> => {
  return httpClient.get(`${API.AUTH_SERVICE.BASE}/${userId}`);
};

export const updateUserData = (userId: string, userData: UpdateUserDTO): Promise<AxiosResponse<ApiData<User>>> => {
  const data = {user: userData};

  return httpClient.put(`${API.AUTH_SERVICE.BASE}/${userId}`, data);
};
